import { BASE_URL } from '@helpers/constants'
import setAuthorization from '@helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const popupsAPI = createApi({
	reducerPath: 'popupsAPI',
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) =>
			setAuthorization(headers, { getState, endpoint }),
	}),
	endpoints: (builder) => ({
		trackPopupClick: builder.mutation<void, { popupId: number }>({
			query: ({ popupId }) => ({
				url: '/popup-trackings',
				method: 'POST',
				body: { popupId },
			}),
		}),
	}),
})

export const { useTrackPopupClickMutation } = popupsAPI
